import React from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const PAGE_SIZE = 30;

// Reusable pagination footer for list tables (30 rows/page).
export const TablePagination = ({ page, total, pageSize = PAGE_SIZE, onPageChange, testId = 'table-pagination', itemLabel = 'entries' }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between gap-3 mt-4 pt-3 border-t" data-testid={testId}>
      <span className="text-xs text-muted-foreground">Showing {start}–{end} of {total} {itemLabel}</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" className="h-8" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid={`${testId}-prev`}>
          <ChevronLeft className="w-4 h-4 mr-1" />Prev
        </Button>
        <span className="text-xs text-muted-foreground">Page {page} of {totalPages}</span>
        <Button variant="outline" size="sm" className="h-8" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} data-testid={`${testId}-next`}>
          Next<ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
};

export default TablePagination;
